$(".slider").slick({
  autoplay: true, //自動的に動き出すか。初期値はfalse。
  infinite: true, //スライドをループさせるかどうか。初期値はtrue。
  slidesToScroll: 1, //1回のスクロールで3枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>', //矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>', //矢印部分NextのHTMLを変更
  dots: true, //下部ドットナビゲーションの表示
  centerMode:true,
  centerPadding: '30%',
  autoplaySpeed: 3100,
  responsive: [
    {
     breakpoint: 768, //767px以下のサイズに適用
      settings: {
        centerPadding: '18%',
      }
    }
  ]
});

$(".slider_trial").slick({
  autoplay: true, //自動的に動き出すか。初期値はfalse。
  infinite: true, //スライドをループさせるかどうか。初期値はtrue。
  slidesToScroll: 1, //1回のスクロールで3枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>', //矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>', //矢印部分NextのHTMLを変更
  dots: true, //下部ドットナビゲーションの表示
  centerMode:true,
  centerPadding: '30%',
  autoplaySpeed: 3100,
  responsive: [
    {
     breakpoint: 768, //767px以下のサイズに適用
      settings: {
        centerPadding: '0',
      }
    }
  ]
});
